import { InputHTMLAttributes } from 'react';
import { isValidEmail, isValidPhone } from 'utils/functions';

export const isValueEmpty = (
  value: string,
  type?: InputHTMLAttributes<HTMLInputElement>['type']
): boolean => {
  if (value.trim() === '') {
    return true;
  }

  if (type === 'number') {
    const numValue = parseFloat(value);
    return isNaN(numValue);
  }

  return false;
};

export const shouldShowError = (
  value: string,
  type: InputHTMLAttributes<HTMLInputElement>['type'],
  showError: boolean
): boolean => {
  if (!showError) {
    return false;
  }

  if (type === 'email') {
    return !isValidEmail(value || '');
  }

  if (type === 'tel') {
    return !isValidPhone(value || '');
  }

  return isValueEmpty(value, type);
};
